import Form from './form.vue'
import FormItem from './form-item'

Form.Item = FormItem
export default (Vue) => {
  Vue.component('AbForm', Form)
  Vue.component('AbFormItem', FormItem)
}
